import React from "react";
import { View } from "react-native";

import { ValidatedInput } from "components";

import { styles } from "./styles";
import { useEmailAddressResponse } from "screens/question/hooks";

export const EmailAddressQuestion = ({ question }) => {
  const {
    value,
    hasError,
    placeholder,
    onChange,
    validateEmail,
  } = useEmailAddressResponse(question);

  return (
    <>
      <View style={styles.container}>
        <ValidatedInput
          placeholder={placeholder}
          value={value}
          keyboardType="email-address"
          hasError={hasError}
          onChangeText={onChange}
          onBlur={() => validateEmail(value)}
        />
      </View>
    </>
  );
};
